import { ChevronsLeftIcon } from 'lucide-react'
import { useDrawer } from '../../../../hooks'
import { CogfyLogo } from '../../../CogfyLogo'

export function DrawerHeader () {
  const { open, setOpen } = useDrawer()

  return (
    <div className="flex flex-row justify-between items-center w-full h-11">
      <CogfyLogo size={48} />
      {open && (
        <div role="button" className="btn btn-sm btn-square btn-ghost" onClick={() => setOpen?.(false)}>
          <ChevronsLeftIcon size={24} />
        </div>
      )}
    </div>
  )
}
